import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';
import http from './http';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import common from './common/function'
import 'swiper/swiper-bundle.css'
import store from './store'
import VueI18n from 'vue-i18n';
import 'animate.css'

import { changeMoney } from '@/common/function';
import { SUPPORT_LANGS, LANG_MANUAL_KEY } from '@/common/languages';

import 'video.js/dist/video-js.css'
Vue.prototype.changeMoney = changeMoney
Vue.prototype.$http = http
Vue.prototype.common = common
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(Vant);
Vue.use(VueI18n);
// 支持的 8 种语言（韩/日/中/马来已下线，老的语言包文件保留但不再加载）
const savedLang = localStorage.getItem('lang');
const i18n = new VueI18n({
  globalInjection: true,
  locale: SUPPORT_LANGS.includes(savedLang) ? savedLang : 'en_us',
  fallbackLocale: 'en_us',
  messages: {
    'en_us': require('./assets/languages/en_us.json'),
    'es_spa': require('./assets/languages/es_spa.json'),
    'fr': require('./assets/languages/fr.json'),
    'de': require('./assets/languages/de.json'),
    'it': require('./assets/languages/it.json'),
    'nl': require('./assets/languages/nl.json'),
    'pt': require('./assets/languages/pt.json'),
    'pl': require('./assets/languages/pl.json'),
  }
});

/**
 * 语言自动切换
 *  - 用户手动切过语言（localStorage.lang_manual）→ 永远以手动为准，不再被覆盖
 *  - 否则：游客按访问 IP 所属地区；已登录按注册地区语言（注册时查一次写入，不重复查询）
 *  服务端接口：/system/lang
 */
function applyServerLang() {
  return new Promise(resolve => {
    // 手动选过语言 → 永远以手动为准
    const manualLang = localStorage.getItem('lang');
    if (localStorage.getItem(LANG_MANUAL_KEY) && SUPPORT_LANGS.includes(manualLang)) {
      resolve();
      return;
    }
    let done = false;
    const finish = () => { if (!done) { done = true; resolve(); } };
    setTimeout(finish, 4000); // 兜底：接口超时/失败就按默认语言渲染
    http({ method: 'get', url: 'sys_lang' }).then(res => {
      const data = (res && res.data) || {};
      if (data.lang && SUPPORT_LANGS.includes(data.lang)) {
        i18n.locale = data.lang;
        localStorage.setItem('lang', data.lang);
      }
      finish();
    }).catch(finish);
  });
}
Vue.prototype.$applyServerLang = applyServerLang;

// 登录后按注册地区语言切换（没有记录的老用户再向服务端要一次）
Vue.prototype.$applyLoginLang = function (lang) {
  const manualLang = localStorage.getItem('lang');
  if (localStorage.getItem(LANG_MANUAL_KEY) && SUPPORT_LANGS.includes(manualLang)) {
    return;
  }
  if (lang && SUPPORT_LANGS.includes(lang)) {
    i18n.locale = lang;
    localStorage.setItem('lang', lang);
    return;
  }
  applyServerLang();
};

applyServerLang().then(() => {
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app');
});
